import React from 'react';
import { X, Command, Keyboard } from 'lucide-react';

interface ShortcutsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ShortcutsModal: React.FC<ShortcutsModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const shortcuts = [
    { key: 'Ctrl + Enter', desc: 'Broadcast current text from Quick Drop' },
    { key: 'Ctrl + K', desc: 'Focus clipboard search input' },
    { key: 'Ctrl + Shift + V', desc: 'Paste latest OS clipboard into dropzone' },
    { key: 'Esc', desc: 'Close any open modal or inspect drawer' },
    { key: '?', desc: 'Toggle keyboard shortcuts reference' },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-md animate-in fade-in duration-200">
      <div className="glass-card w-full max-w-md p-6 shadow-2xl border border-white/10 relative">
        <div className="flex items-center justify-between pb-4 border-b border-white/10">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-xl bg-cyan-950/60 border border-cyan-500/30 flex items-center justify-center text-cyan-400">
              <Keyboard size={18} />
            </div>
            <div>
              <h2 className="text-base font-bold text-white font-display">Keyboard Shortcuts</h2>
              <p className="text-[11px] text-slate-400">Power user ergonomics and fast navigation</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 text-slate-400 hover:text-white rounded-xl hover:bg-white/5 transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        <div className="py-4 space-y-2.5">
          {shortcuts.map((s) => (
            <div
              key={s.key}
              className="flex items-center justify-between p-2.5 rounded-xl bg-[#090A12] border border-white/5"
            >
              <span className="text-xs text-slate-300 font-medium">{s.desc}</span>
              <kbd className="font-mono text-xs bg-black/60 text-cyan-300 border border-white/10 px-2.5 py-1 rounded-lg shadow-inner">
                {s.key}
              </kbd>
            </div>
          ))}
        </div>

        <div className="pt-3 border-t border-white/10 text-center">
          <button onClick={onClose} className="btn-secondary w-full text-xs py-2">
            Close Shortcuts
          </button>
        </div>
      </div>
    </div>
  );
};
